module.exports = __webpack_public_path__ + "88a090f121b4043f5b6b88bde21f39b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/header.jpg
// module id = 343
// module chunks = 0